import { ADMIN_MESSAGE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function PostAdminMessage(data){
    const api = `${ADMIN_MESSAGE_API}ordinary/`;
    return axiosHttp.post(api, data);
}
